import type { AxiosRequestConfig } from 'axios'

/** 后端 API 请求配置 */
export const API_CONFIG: AxiosRequestConfig = {
  baseURL: import.meta.env.VITE_API_BASE_URL || '',
  timeout: 15000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
}

/** 本地存储键名 */
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  REFRESH_TOKEN: 'refresh_token',
} as const

/** 请求头键名 */
export const HEADER_KEYS = {
  AUTHORIZATION: 'Authorization',
  TRACE_ID: 'X-Trace-Id',
} as const

/** 业务状态码 */
export const BUSINESS_CODE = {
  SUCCESS: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
} as const

/** 环境相关配置 */
export const ENV_CONFIG = {
  api: {
    /** 是否启用请求去重（开发环境默认开启） */
    enableDedup: true,
    /** 是否启用请求日志（仅开发环境） */
    enableRequestLog: import.meta.env.DEV,
  },
} as const
